<script setup>
// Astra DS · BrandTicketmaster — el botón de compra de los conciertos que se
// venden en Ticketmaster.
//
// Figma: `Brand/Ticketmaster 2268:202`, en `02 — Components`. Entrega
// `docs/entregas/2026-09-27-ticketmaster-o-contorno.md`. Decidido por Pablo el
// 27.09.26: solo lo llevan los conciertos que se venden en Ticketmaster; el
// resto lleva el `cta` de contorno «COMPRAR ENTRADAS».
//
// ── Es una marca ajena, y una excepción declarada ──
//
// Como `StoreBadge`: **su azul y su radio valen para este componente y para
// nada más**. `#004CE4` es el azul de Ticketmaster y no tiene token, y no
// cambia con el modo. No cuelga de `01.5 — Iconography`.
//
// ── El distintivo es una imagen, y no se toca ──
//
// Es el oficial —«ticketmaster® · entradas en ticketmaster.es»— y se exporta
// del propio nodo (`distintivo 2270:202`, 104 × 30) a 4×, con el fondo azul ya
// dentro: es el mismo `#004CE4` al píxel, comprobado. **Ni se recorta ni se
// recolorea**, lo dice la descripción del componente en la Library.
//
// Sin `alt` vacío: el texto del distintivo es lo único que dice a dónde lleva,
// así que es la etiqueta del enlace.
import distintivo from "@/assets/marcas/ticketmaster-distintivo.png";

defineProps({
  href: { type: String, required: true },
  // `md` (`2268:202`), el de siempre, 128 × 42. `sm` (`2591:216`, 21.10.26),
  // 100 × 32 con el distintivo escalado entero a 80 × 23: solo para la compra de
  // cada fecha en la franja con varias fechas.
  tamano: { type: String, default: "md", validator: (v) => ["md", "sm"].includes(v) },
});
</script>

<template>
  <a class="brand-tm" :class="`brand-tm--${tamano}`" :href="href" target="_blank" rel="noopener noreferrer">
    <img
      class="brand-tm__distintivo"
      :src="distintivo"
      alt="Entradas en Ticketmaster"
      width="104"
      height="30"
    />
  </a>
</template>

<style scoped lang="scss">
.brand-tm {
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  // 42 de alto, el del `cta` de contorno: 6 + 30 + 6.
  height: 42px;
  // 12 a los lados; el ancho —128— lo abraza el distintivo.
  padding: 6px 12px;
  // 🔴 **Radio 8 (`radius/md`), acotado a este componente.** DESIGN.md
  // § Shapes lo recoge junto a `StoreBadge`: es un distintivo ajeno y se
  // reconoce por su forma.
  border-radius: 8px;
  overflow: hidden;
  // Color de marca ajena, sin token y el mismo en los dos modos.
  background: #004ce4;
  text-decoration: none;

  // El nodo no dibuja estados. Se usa la misma respuesta que `StoreBadge`,
  // la otra marca ajena de la casa: bajar la opacidad, que no recolorea nada.
  &:hover {
    opacity: 0.85;
  }

  &:focus-visible {
    outline: 2px solid var(--color-border-focus);
    outline-offset: 2px;
  }
}

.brand-tm__distintivo {
  display: block;
  flex: none;
  width: 104px;
  height: 30px;
}

// `Tamaño=sm`: 32 de alto, relleno 4 · 10, el mismo radio y el mismo azul.
.brand-tm--sm {
  height: 32px;
  padding: 4px 10px;

  .brand-tm__distintivo {
    width: 80px;
    height: 23px;
  }
}
</style>
